import React from "react"
import Link from "~components/Link"
import { withMicrocopy } from "~contexts/MicrocopyContext"
import * as style from "./FeaturedBoard.module.scss"

import communityImage from './community.png'
import sampleCodeImage from './sampleCode.png'
import aiDevZoneImage from './aiDevZone.png'

const FeaturedBoard = ({ type, microcopy }) => {
  const tag = type ? `pages.featured_board.${type}.tag` : ''
  const headline = type ? `pages.featured_board.${type}.headline` : ''
  const text = type ? `pages.featured_board.${type}.text` : ''
  const cta = type ? `pages.featured_board.${type}.cta` : ''
  const link = type ? `pages.featured_board.${type}.link` : ''
  return (
    <div className={style.wrapper}>
      <figure className={style.figure}>
        {type === "community"
          && <img alt="" className={style.communityImg} src={communityImage} />}
        {type === "sampleCode"
          && <img alt="" src={sampleCodeImage} />}
        {type === "aiDevZone"
          && <img alt="" src={aiDevZoneImage} />}
      </figure>
      <div className={style.content}>
        { type
          && (
          <span className={`${style.tag} ${type === "aiDevZone" ? style.tagNew : style.tagFeatured}`}>
            {microcopy.text(tag)}
          </span>
          )}

        {headline
          && (
          <h2 className={style.headline}>
            {microcopy.text(headline)}
          </h2>
          )}
        {text
          && (
          <p className={style.text}>
            {microcopy.text(text)}
          </p>
          )}
        <Link to={microcopy.text(link)} className={style.link}>
          {microcopy.text(cta)}
        </Link>
      </div>
    </div>
  )
}

export default withMicrocopy(FeaturedBoard)
